'use client'

import {
  FacebookIcon,
  InstagramIcon,
  TiktokIcon,
} from '@/components/icons'
import { MailIcon } from 'lucide-react'
import Link from 'next/link'

export function Footer() {
  return (
    <div className="justify-items-left grid h-auto w-full grid-cols-2 items-start gap-8 bg-zinc-900 px-6 py-12 text-white lg:grid-cols-5 lg:px-[80px] lg:py-[40px]">
      <div className="flex flex-col gap-y-[19px]">
        <h1 className="font-darkergrotesque text-[20px] font-bold">
          Contester Members
        </h1>
        <ul className="list-disc pl-5 text-[14px]">
          <li>กิจกรรมสำหรับสมาชิก</li>
        </ul>
      </div>
      <div className="flex flex-col gap-y-[19px]">
        <h1 className="font-darkergrotesque text-[20px] font-bold">
          Follow Us
        </h1>
        <ul className="flex list-none flex-col gap-2 text-[14px]">
          <li>
            <Link
              href="https://www.instagram.com/contester.life/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <InstagramIcon className="h-4 w-4 text-white" />
              <span>Instagram</span>
            </Link>
          </li>
          <li>
            <Link
              href="https://www.facebook.com/profile.php?id=61572754773676"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <FacebookIcon className="h-4 w-4 text-white" />
              <span>Facebook</span>
            </Link>
          </li>
          <li>
            <Link
              href="https://www.tiktok.com/@contester.life"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <TiktokIcon className="h-4 w-4 text-white" />
              <span>TikTok</span>
            </Link>
          </li>
          {/* <li>
            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <YoutubeIcon className="h-4 w-4 text-white" />
              <span>YouTube</span>
            </a>
          </li> */}
        </ul>
      </div>
      <div className="flex flex-col gap-y-[19px]">
        <h1 className="font-darkergrotesque text-[20px] font-bold">
          Contact Us
        </h1>
        <ul className="flex list-disc flex-col gap-2 text-[14px]">
          <li>
            <Link
              href="mailto:contact@contester.life"
              className="flex items-center gap-2"
            >
              <MailIcon className="h-4 w-4 text-white" />
              <span>Contact@Contester.life</span>
            </Link>
          </li>
          {/* <li>
            <MailIcon className="h-4 w-4 text-white" />
            <span>Contester.life@gmail.com</span>
          </li>
          <li>
            <LINEIcon className="h-4 w-4 text-white" />
            <span>@contester.life</span>
          </li> */}
        </ul>
        <Link href="/contest/submit" className="w-fit rounded-full border border-white bg-zinc-900 px-[16px] py-1 text-[14px] font-bold text-white">
          ส่งงานแข่งฟรี!
        </Link>
      </div>
      <div className="flex flex-col gap-y-[19px]">
        <h1 className="font-darkergrotesque text-[20px] font-bold">
          Help Center
        </h1>
        <ul className="list-disc pl-5 text-[14px]">
          <li>โฆษณาในเว็บไซต์ และ สื่อออนไลน์</li>
          <li>จัดเวิร์กชอปพัฒนาทักษะ</li>
          <li>จัด Event และ Hackathon</li>
          <li>บริการอื่น ๆ</li>
        </ul>
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-y-[19px]">
          <h1 className="font-darkergrotesque text-[20px] font-bold">
            Legal
          </h1>
          <ul className="list-disc pl-5 text-[14px]">
            <li>นโยบายความเป็นส่วนตัว</li>
            <li>ข้อตกลงการใช้งาน</li>
          </ul>
        </div>
        <div className="hidden flex-col gap-y-[19px] lg:flex">
          <h1 className="font-darkergrotesque text-[20px] font-bold">Other</h1>
          <ul className="list-disc pl-5 text-[14px]">
            <li>Winner Announcement</li>
            <li>Achieve</li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col gap-y-[19px] lg:hidden">
        <h1 className="font-darkergrotesque text-[20px] font-bold">Other</h1>
        <ul className="list-disc pl-5 text-[14px]">
          <li>Winner Announcement</li>
          <li>Achieve</li>
        </ul>
      </div>
    </div>
  )
}
